import {take, call, put} from 'redux-saga/effects'

import {SENDING_ALL_SYSTEM_REQUEST, FETCH_ALL_SYSTEM_REQUEST, FETCH_ALL_SYSTEM_SUCCESS, FETCH_ALL_SYSTEM_FAILURE} from '../actions/constants'
import system from '../api/system'
import {putNotify} from './utils'

function* fetchAllSystems() {
  try {
    yield put({type: SENDING_ALL_SYSTEM_REQUEST, sending: true})
    return yield call(system.fetchSystem)
  } catch (error) {
    yield put({type: FETCH_ALL_SYSTEM_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_ALL_SYSTEM_REQUEST, sending: false})
  }
}

export function* watchFetchAllSystems() {
  while (true) {
    yield take(FETCH_ALL_SYSTEM_REQUEST)
    const response = yield call(fetchAllSystems)
    const arr = yield call(putNotify, {response})
    const systems = Array.isArray(arr)
      ? arr
      : []

    yield put({type: FETCH_ALL_SYSTEM_SUCCESS, systems: systems});
  }
}



// WEBPACK FOOTER //
// ./src/sagas/system.js